'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HostContainer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _ = require('../');

var _HostContainer = require('./HostContainer.scss');

var _HostContainer2 = _interopRequireDefault(_HostContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HostContainer(props) {
  var rules = props.rules,
      onChangeInclude = props.onChangeInclude,
      onChangeFormat = props.onChangeFormat,
      saveState = props.saveState;


  return _react2.default.createElement(
    'div',
    { className: _HostContainer2.default.root },
    _react2.default.createElement(
      'div',
      { className: _HostContainer2.default.headerText },
      'HOST/API CARRIERS'
    ),
    _react2.default.createElement(_.HostCarriersTable, { rules: rules,
      onChangeInclude: onChangeInclude,
      onChangeFormat: onChangeFormat,
      saveState: saveState
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Rules/Components/HostContainer/HostContainer.jsx
// module id = 1463
// module chunks = 0